module.exports = __webpack_public_path__ + "img/qualification.a1b4bbaf.png";